import { createSelector } from '@reduxjs/toolkit';

// Account selectors
export const selectUserData = createSelector(
  (state) => state.account.userData,
  (userData) => userData
);

export const selectAuthDetails = createSelector(
  (state) => state.account.authDetails,
  (authDetails) => authDetails
);

export const selectAnnouncement = createSelector(
  (state) => state.account.announcement,
  (announcement) => announcement
);

export const selectChangePasswordPopOpen = createSelector(
  (state) => state.account.ui.changePasswordPopOpen,
  (val) => val
);

export const selectChangeButtonPopOpen = createSelector(
  (state) => state.account.ui.changeButtonPopOpen,
  (val) => val
);

export const selectMyMarketPopOpen = createSelector(
  (state) => state.account.ui.myMarketPopOpen,
  (val) => val
);

// Game selectors
export const selectSelectedEventForBet = createSelector(
  (state) => state.gameData.selectedEventForBet,
  (bet) => bet
);

export const selectInplaySocketConnected = createSelector(
  (state) => state.gameData.inplaySocketConnected,
  (connected) => connected
);

export const selectCricketInPlayGames = createSelector(
  (state) => state.gameData.cricketInPlayGames,
  (games) => games
);

export const selectTennisInPlayGames = createSelector(
  (state) => state.gameData.tennisInPlayGames,
  (games) => games
);

export const selectSoccerInPlayGames = createSelector(
  (state) => state.gameData.soccerInPlayGames,
  (games) => games
);

// Dynamic selectors (factories)
export const selectInPlayGames = (sportName) =>
  createSelector(
    (state) => state.gameData[sportName + 'InPlayGames'],
    (games) => games
  );

export const selectGameOdds = (game, eventId) =>
  createSelector(
    (state) => state.gameData[game + 'Odds'],
    (odds) => (odds ? odds[eventId] : undefined)
  );

export const selectGameSettings = (game, eventId) =>
  createSelector(
    (state) => state.gameData[game + 'Settings'],
    (settings) => (settings && settings[eventId] ? settings[eventId] : settings)
  );

export const selectDiamondCasinoGames = createSelector(
  (state) => state.gameData.diamondCasinoGames,
  (games) => games
);
